/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:09:29
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-09 16:11:17
 */
import req from "@/utils/request";

//  get 请求示列
export const selectListPage = (params) => req.post("/manager-service/m/journal/selectListPage", params);
